import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1844c741"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Next ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppInput = _resolveComponent("AppInput")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_Form = _resolveComponent("Form")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, { direction: "vertical" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_Form, {
          as: "el-form",
          "validation-schema": _ctx.schema,
          onSubmit: _ctx.nextStep
        }, {
          default: _withCtx(() => [
            _createVNode(_component_AppInput, {
              "control-class": "mb-48",
              name: "groupName",
              label: "Group Info",
              placeholder: "Add information about your group",
              clearable: "",
              modelValue: _ctx.inputData,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputData) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_AppButton, {
              class: "w-100 el-button is-round",
              "native-type": "submit",
              type: "primary",
              disabled: _ctx.inputData.length === 0 || _ctx.dataLoading
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }, 8, ["validation-schema", "onSubmit"])
      ])
    ]),
    _: 1
  }))
}